export const ARGUMENT_NAME = {
    ACCOUNT_ID: 'accountId',
    SEARCH_INPUT: 'searchInput',
    PAGE: 'page',
    PAGE_SIZE: 'pageSize',
    QUERY_PARAMS: 'queryParams',
};
